import CircularProgress from '@mui/material/CircularProgress';
import React from 'react';
interface IModalCommon {
  handleClose?: () => void;
  title?: string;
  paragraph?: React.ReactNode;
  handleDelete?: any;
  isLoading?: boolean;
  /** Confirm button text; defaults to "Delete". */
  confirmLabel?: string;
  /** Confirm button text while loading; defaults to "Deleting". */
  loadingLabel?: string;
}
const DeleteCommonModal: React.FC<IModalCommon> = ({
  handleClose,
  title,
  paragraph,
  handleDelete,
  isLoading,
  confirmLabel = 'Delete',
  loadingLabel = 'Deleting',
}) => {
  return (
    <div className='audit-add-modal-cont'>
      <div className='audit-add-modal-cont-head'>
        <div className='audit-add-modal-head-cont'>
          <div className='audit-add-modal-head-cont-icons'>
            <svg
              xmlns='http://www.w3.org/2000/svg'
              width='24'
              height='24'
              viewBox='0 0 24 24'
              fill='none'
            >
              <path
                d='M16 6V5.2C16 4.0799 16 3.51984 15.782 3.09202C15.5903 2.71569 15.2843 2.40973 14.908 2.21799C14.4802 2 13.9201 2 12.8 2H11.2C10.0799 2 9.51984 2 9.09202 2.21799C8.71569 2.40973 8.40973 2.71569 8.21799 3.09202C8 3.51984 8 4.0799 8 5.2V6M10 11.5V16.5M14 11.5V16.5M3 6H21M19 6V17.2C19 18.8802 19 19.7202 18.673 20.362C18.3854 20.9265 17.9265 21.3854 17.362 21.673C16.7202 22 15.8802 22 14.2 22H9.8C8.11984 22 7.27976 22 6.63803 21.673C6.07354 21.3854 5.6146 20.9265 5.32698 20.362C5 19.7202 5 18.8802 5 17.2V6'
                stroke='#F04438'
                strokeWidth='2'
                strokeLinecap='round'
                strokeLinejoin='round'
              />
            </svg>
          </div>
          <div className='audit-add-modal-head-cont-supporting'>
            <h1>{title}</h1>
            <p style={{ color: 'var(--card-text)', fontWeight: '400', lineHeight: '20px' }}>{paragraph}</p>
          </div>
        </div>
        <div className='audit-add-modal-head-close' onClick={handleClose}>
          <svg
            xmlns='http://www.w3.org/2000/svg'
            width='24'
            height='24'
            viewBox='0 0 24 24'
            fill='none'
          >
            <path
              d='M18 6L6 18M6 6L18 18'
              stroke='#85888E'
              strokeWidth='2'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
          </svg>
        </div>
      </div>
      <div className='audit-modal-cont-footer'>
        <div className='audit-modal-cont-footer-content'>
          <div
            className='audit-modal-cont-footer-content-btn-cancel'
            onClick={handleClose}
          >
            <div className='audit-modal-cont-footer-content-btn-text'>
              Cancel
            </div>
          </div>
          <div
            className='audit-modal-cont-footer-content-btn-delete'
            onClick={handleDelete}
          >
            <div className='audit-modal-cont-footer-content-btn-text' style={{ color: '#FFF' }}>
              {isLoading ? (
                <>
                  <CircularProgress
                    style={{
                      width: '30px',
                      height: '30px',
                      marginRight: '10px',
                    }}
                    color='error'
                  />{' '}
                  {loadingLabel}
                </>
              ) : (
                <>{confirmLabel}</>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeleteCommonModal;
